import React from "react";
import { SegmentCardProps } from "../types/appTypes";

const SegmentCard: React.FC<SegmentCardProps> = ({
  title,
  description,
  amount,
  text,
}) => {
  return (
    <div className="flex flex-col items-center bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-white/20 h-full">
      <h3 className="text-2xl font-bold mb-4 text-white">{title}</h3>
      <p className="text-gray-200 mb-8 text-center flex-grow">{description}</p>
      <div className="text-center border-t border-white/20 pt-6 w-full">
        <p className="text-lg font-semibold mb-3 text-yellow-400">{text}</p>
        <p className="text-4xl font-bold text-white">{amount}</p>
      </div>
    </div>
  );
};

export default SegmentCard;
